import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgxImageCompressService } from 'ngx-image-compress';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { DeleteImageComponent } from '../delete-image/delete-image.component';
import { SubmittedFormPreviewService } from '../submitted-form-preview/submitted-form-preview.service';
import { NgbDateFRParserFormatter } from '../fixed-hazard-form/fixed-format-date';
import { FixActionService } from './fix-action.service';
import { ImagePreviewComponent } from '../image-preview/image-preview.component';
import { Constants } from '../constants';
@Component({
  selector: 'app-fixed-hazard-form',
  templateUrl: './fix-action-form.component.html',
  styleUrls: ['./fix-action-form.component.scss'],
  providers: [NgbDatepickerConfig, { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }]

})
export class FixActionFormComponent implements OnInit {
  @Input() name: string;
  @ViewChild('disp') iframe: ElementRef;
  @ViewChild('inputFiles') myInputVariable: ElementRef;
  urls = [];
  imageSrc;
  album;
  fixActionField: any;
  actionForm;
  taskId;
  hazardNotifiyArray;
  minimumFiveImage = false;
  PresentDay: any;
  actionPreview = false;
  hAssignedToValues:any;
  fixedUrls = [];
  priorityObj = {
    '0': 'Critical',
    '1': 'High',
    '2': 'Medium',
    '3': 'Info'
  };
  popupImage = {} = this.urls;
  deleteIndex = {} = this.urls;
  categoryObj = {
    '0': 'Electrical',
    '2': 'Guarding',
    '1': 'Housekeeping',
    '3': 'Other'
  };
  hazardNotifiyObj = {
    '0': 'I have verbally informed nearby miners',
    '1': 'Reported Hazard over Radio',
    '2': 'Reported Hazard to Supervisor',
    '3': 'Digitally recorded'
  };
  sumArray = [];
  categoryArray = [];
  get priorityKey() {
    return Object.keys(this.priorityObj);
  }
  get categoryKey() {
    return Object.keys(this.categoryObj);
  }
  get hazardNotifiyKey() {
    return Object.keys(this.categoryObj);
  }
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _submittedFormPreviewService: SubmittedFormPreviewService,
    private _capabilityEngineService: CapabilityEngineService,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private domSanitizer: DomSanitizer,
    private _fixActionService: FixActionService,
    private imageCompress: NgxImageCompressService,
    private modalService: NgbModal,
    private constants: Constants
  ) {
    const src = '';
    const thumb = '';
    const album = {
      src: src,
      thumb: thumb
    };
    this.PresentDay = this.getFormattedDate(new Date());

  }
  onSelectFile(event, image, orientation) {
    this.minimumFiveImage = false;
    if (event.target.files && event.target.files[0]) {
      let filesAmount = event.target.files.length;
      if (filesAmount + this.urls.length <= 5) {
        if (filesAmount <= 5) {
          for (let i = 0; i < filesAmount; i++) {
            let file = event.target.files[i];
            let reader = new FileReader();
            reader.onload = (event: Event) => {
              this.imageCompress.compressFile(reader.result, orientation, 50, 50).then(
                result => {
                  this.urls.push({
                    file: file,
                    src: reader.result,
                    thumb: result
                  });
                  this.myInputVariable.nativeElement.value = '';
                }
              );
            };
            reader.readAsDataURL(file);
          };
        }
      } else {
        this.minimumFiveImage = true;
      }
    }
  }
  openImage(img,type){
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-lg light-modal',
    };
    const modalRef = this.modalService.open(ImagePreviewComponent, modalOptions);
    if(type === 'mobile'){
    modalRef.componentInstance.imageSrc = this.getBase64String(img);
    }else{
      modalRef.componentInstance.imageSrc = img;
    }
  }
  goBack() {
    this.actionPreview = !this.actionPreview;
  }
  ngOnInit() {
    const pathData = this._activatedRoute.data['_value'];
    if (this.canPerform(pathData.capabilities)) {
      this._submittedFormPreviewService.getSubmittedFormPreviewHtml(this._activatedRoute.snapshot.params['id'])
        .subscribe((result: any) => {
          console.log('actionFormcomponent -> ngOnInit -> result', result);
          this.fixActionField = result.data.dbTask.data.data;
          this.hAssignedToValues = (this.fixActionField.hAssignedTo) ? Object.values(this.fixActionField.hAssignedTo) : '';
          this.taskId = result.data.dbTask._id;
          this.actionForm = this._formBuilder.group({
            hazardDescription: this.fixActionField.hazardDescription,
            reportedOn: this.fixActionField.reportedOn = moment(this.fixActionField.reportedOn).format('MMM DD, YYYY'),
            hCategory: this.categoryArray,
            hPriority: this.sumArray,
            hNotifiedTo: this.hazardNotifiyArray,
            actionCorrection: 'Yes',
            newWorkOrder: this.fixActionField.actionWorkOrder,
            fixedOn: this.fixActionField.fixedOn,
            fixedDescription: '',
            fixedBy: '',
            fixedImages: this.urls,
            hazardImages: '',
            hDueDate : this.fixActionField.hDueDate = moment(this.fixActionField.hDueDate).format('MMM DD, YYYY'),
            hAssignedTo : ''
          });
          this.actionForm.get('hAssignedTo').value = this.hAssignedToValues;
        }, (err) => {
          console.log('actionFormcomponent -> ngOnInit -> ', err);
        });
    }
  };
  previewactionForm() {

    const formData: FormData = new FormData();

    const actionData = _.pick(this.actionForm.value, ['fixedDescription', 'fixedOn', 'fixedBy'])
    formData.append('data', JSON.stringify(actionData));
    formData.append('taskId', this.taskId);

    var thumbnails = {};
    _.forEach(this.actionForm.value.fixedImages, (imageAlbum, index) => {
      const file: File = imageAlbum.file;
      const fileName = this.taskId + '_' + index;
      formData.append(fileName, file);
      thumbnails[fileName] = imageAlbum.thumbnail;
    });

    formData.append('thumbnails', JSON.stringify(thumbnails));

    this._fixActionService.updateActionForm(formData)
      .subscribe(
        (res: any) => {
          this._router.navigateByUrl(
            '/actions/' +  this.getActionTemplateId() + '?formType=action'
          );
        },
        err => {
          console.log(err);
        }
      );
  };
  updateDetails() {
    let highPriority = this.actionForm.get('hPriority').value;
    let hazardNotify = this.actionForm.get('hNotifiedTo').value;
    let hazardCategory = this.actionForm.get('hCategory').value;
    let hazardCorrect = this.actionForm.get('actionCorrection').value;
    if (highPriority === null || hazardCategory === null || hazardNotify === null) {
      this.sumArray = [];
      this.categoryArray = [];
      this.hazardNotifiyArray = [];
      this.sumArray = [this.fixActionField.hPriority];
      this.categoryArray = [this.fixActionField.hCategory];
      this.hazardNotifiyArray = [this.fixActionField.hNotifiedTo];
    } else {
      this.sumArray = [];
      if (highPriority === this.priorityObj[0] || hazardCategory === this.categoryObj[0] || hazardNotify === this.hazardNotifiyObj[0]) {
        this.sumArray.push({ '0': 'Critical' });
        this.categoryArray.push({ '0': 'Electrical' });
        this.hazardNotifiyArray.push({ '0': 'I have verbally informed nearby miners' });
      } else if (highPriority === this.priorityObj[1] || hazardCategory === this.categoryObj[1] || hazardNotify === this.hazardNotifiyObj[1]) {
        this.sumArray.push({ '1': 'High' });
        this.categoryArray.push({ '1': 'Guarding' });
        this.hazardNotifiyArray.push({ '1': 'Reported Hazard over Radio' });
      } else if (highPriority === this.priorityObj[2] || hazardCategory === this.categoryObj[2] || hazardNotify === this.hazardNotifiyObj[2]) {
        this.sumArray.push({ '2': 'Medium' });
        this.categoryArray.push({ '2': 'Housekeeping' });
        this.hazardNotifiyArray.push({ '2': 'Reported Hazard over Supervisor' });
      } else if (highPriority === this.priorityObj[3] || hazardCategory === this.categoryObj[3] || hazardNotify === this.hazardNotifiyObj[3]) {
        this.sumArray.push({ '3': 'Info' });
        this.sumArray.push({ '3': 'Other' });
        this.hazardNotifiyArray.push({ '3': 'Digitally recorded' });
      }
    }
    let hazardCorectionArray = [];
    if (hazardCorrect === null) {
      hazardCorectionArray = [this.fixActionField.actionCorrection];
    } else {
      if (hazardCorrect === 'Yes') {
        hazardCorectionArray.push({ '0': 'Yes' });
      } else {
        hazardCorectionArray.push({ '1': 'No' });
      }
    }
    this.actionForm.value.actionCorrection = hazardCorectionArray[0];
    this.actionForm.value.hPriority = this.sumArray[0];
    this.actionForm.value.hCategory = this.categoryArray[0];
    this.actionForm.value.hNotifiedTo = this.hazardNotifiyArray[0];
    this.actionForm.value.fixedImages = _.map(this.urls, (url) => {
      let imageUrl = (url.src).replace('data:image/png;base64,', '');
      imageUrl = imageUrl.replace('data:image/jpeg;base64,', '');

      let thumbImageUrl = (url.thumb).replace('data:image/png;base64,', '');
      thumbImageUrl = thumbImageUrl.replace('data:image/jpeg;base64,', '');

      return { file: url.file, image: imageUrl, thumbnail: thumbImageUrl };;
    });
    this.actionForm.value.hazardImages = this.fixActionField.hazardImages;
    const momentObj = moment(new Date());
    const momentString = momentObj.format('THH:mm:ss.SSSZ');

    const fixedOnDate = this.actionForm.get('fixedOn').value;
    const month = (((fixedOnDate.month + '').length > 1) ? (fixedOnDate.month) : ('0' + fixedOnDate.month));
    const day = (((fixedOnDate.day + '').length > 1) ? (fixedOnDate.day) : ('0' + fixedOnDate.day));;
    this.actionForm.value.fixedOn = fixedOnDate.year + '-' + month + '-' + day + momentString;

    console.log(this.actionForm.value);
    let updatedObj = {
      data: {
        data: this.actionForm.value
      },
      taskId: this.taskId
    };
    this._fixActionService.previewActionForm(updatedObj).subscribe(
      (res: any) => {
        let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
        doc.open();
        doc.write(res.data.html);
        doc.close();
      }
    );
    this.actionPreview = true;
  }
  canPerform(data) {
    return this._capabilityEngineService.canPerform(data);
  }
  getBase64String(str) {
    return 'data:image/jpg;base64,' + str;
  }
  getFormattedDate(date) {
    return {
      year: moment(date).year(),
      month: moment(date).month() + 1, // This is because in moment() months numbered from 0 to 11.
      day: moment(date).date()
    };
  }
  // defaulted to 0.
  deleteImage(i = 0) {
        let modalOptions: any = {
            size: 'md',
            centered: true,
            windowClass: 'md-dialog-small',
        };
        const modalRef = this.modalService.open(DeleteImageComponent, modalOptions);
        modalRef.componentInstance.popupImage = this.popupImage;
        modalRef.componentInstance.deleteIndex =  i;
        console.log( modalRef.componentInstance.popupImage);
        console.log( modalRef.componentInstance.deleteIndex);
    }

    getHazardTemplateId() {
      if(localStorage.getItem("hazardTemplateId")) {
        return localStorage.getItem("hazardTemplateId")
      } else {
        return this.constants.HAZARD_TEMPLATE_ID
      }
    }
    getActionTemplateId() {
      if(localStorage.getItem("actionTemplateId")) {
        return localStorage.getItem("actionTemplateId")
      } else {
        return this.constants.ACTION_TEMPLATE_ID
      }
    }
}




// WEBPACK FOOTER //
// ./src/app/fix-action-form/fix-action-form.component.ts